import { makeStyles } from '@mui/styles';

import { IAlyceCustomTheme } from '../../../../styles/alyceTheme';

export const useStyles = makeStyles<IAlyceCustomTheme>(({ spacing, palette }) => ({
  chipsContainer: {
    '& > *': {
      margin: spacing(0, 0.5, 1),
    },
  },
  checkbox: {
    color: `${palette.customStyling.backgroundColor} !important`,
  },
  chipRoot: {
    backgroundColor: palette.customStyling.secondaryColor,
    color: palette.customStyling.secondaryCtaColor,
  },
  chipDeleteIcon: {
    color: `${palette.customStyling.secondaryCtaColor} !important`,
    '&:hover': {
      color: palette.customStyling.secondaryCtaColor,
    },
  },
  chipLinkButton: {
    color: palette.customStyling.highlightColor,
  },
  sidebarHeaderRoot: {
    backgroundColor: palette.customStyling.backgroundColor,
    color: palette.customStyling.headlineColor,
  },
  sidebarHeaderIcon: {
    color: palette.customStyling.headlineColor,
  },
}));
